import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Config, I18n, I18nContext } from "@deporvillage/utils-library-component";
import Picture from "@deporvillage/picture-component";
import FooterReviews from './FooterReviews.js';

import styles from './FooterDesktop.module.scss';

const FooterContent = ({ showBlogLink, stores, rating }) => {

    const { page, lang, trustpilot } = useContext(Config);
    const { translate } = useContext(I18nContext);

    // TODO: temp fix exxlude new domains
    const otherLangStores = stores.filter(store => store.lang !== lang && ['nl', 'da', 'pl'].indexOf(store.lang) === -1);

    return (
        <div className={styles['footer-desktop-content']}>

            {
                trustpilot?.enabled?.widget && (
                    <FooterReviews rating={rating}/>
                )
            }

            <ul className={!trustpilot || !trustpilot?.enabled?.widget ? styles['footer-desktop-link-block'] : ''}>
                <li className={styles['footer-desktop-link-title']}>
                    <strong>
                        <I18n>footer.links.about_deporvillage</I18n>
                    </strong>
                </li>
                <li>
                    <a rel='nofollow' href={translate('footer.links.about_us_link')}>
                        <I18n>footer.links.about_us</I18n>
                    </a>
                </li>
                <li>
                    <a rel='nofollow' href={translate('footer.links.press_link')}>
                        <I18n>footer.links.press</I18n>
                    </a>
                </li>
                <li>
                    <a rel='nofollow' href={translate('footer.links.advantages_link')}>
                        <I18n>footer.links.advantages</I18n>
                    </a>
                </li>
                <li>
                    <a href={translate('footer.links.work_with_us_link')}>
                        <I18n>footer.links.work_with_us</I18n>
                    </a>
                </li>
                <li>
                    <a href={translate('footer.links.stores_link')}>
                        <I18n>footer.links.stores</I18n>
                    </a>
                </li>
            </ul>

            <ul>
                <li className={styles['footer-desktop-link-title']}>
                    <strong>
                        <I18n>footer.links.guarantees</I18n>
                    </strong>
                </li>
                <li>
                    <a rel='nofollow' href={translate('footer.links.returns_link')}>
                        <I18n>footer.links.returns</I18n>
                    </a>
                </li>
                <li>
                    <a rel='nofollow' href={translate('footer.links.delivery_link')}>
                        <I18n>footer.links.delivery</I18n>
                    </a>
                </li>
                <li>
                    <a rel='nofollow' href={translate('footer.links.payment_methods_link')}>
                        <I18n>footer.links.payment_methods</I18n>
                    </a>
                </li>
                <li>
                    <a rel='nofollow' href={translate('footer.links.secure_purchase_link')}>
                        <I18n>footer.links.secure_purchase</I18n>
                    </a>
                </li>
            </ul>
            <ul>
                <li className={styles['footer-desktop-link-title']}>
                    <strong>
                        <I18n>footer.links.customer_service</I18n>
                    </strong>
                </li>
                <li>
                    <a rel='nofollow' href={translate('footer.links.help_link')}>
                        <I18n>footer.links.help</I18n>
                    </a>
                </li>
                <li>
                    <a rel='nofollow' href={translate('footer.links.tracking_link')}>
                        <I18n>footer.links.tracking</I18n>
                    </a>
                </li>
                <li>
                    <a rel='nofollow' href={translate('footer.links.shipping_link')}>
                        <I18n>footer.links.shipping</I18n>
                    </a>
                </li>
                <li>
                    <a rel='nofollow' href={translate('footer.links.size_change_link')}>
                        <I18n>footer.links.size_change</I18n>
                    </a>
                </li>
                <li>
                    <a rel='nofollow' href={translate('footer.links.billing_link')}>
                        <I18n>footer.links.billing</I18n>
                    </a>
                </li>
            </ul>
            <ul>
                <li className={styles['footer-desktop-link-title']}>
                    <strong>
                        <I18n>footer.links.more_deporvillage</I18n>
                    </strong>
                </li>
                <li>
                    <a href={translate('footer.links.events_link')}>
                        <I18n>footer.links.events</I18n>
                    </a>
                </li>
                {showBlogLink ? (
                    <li>
                        <a href={translate('footer.links.blog_link')} target="_blank" rel="noreferrer">
                            <I18n>footer.links.blog</I18n>
                        </a>
                    </li>
                ) : null}
            </ul>
            <ul>
                {otherLangStores.length && (
                    <>
                        <li className={styles['footer-desktop-link-title']}>
                            <strong>
                                <I18n>footer.langs.title</I18n>
                            </strong>
                        </li>
                        {otherLangStores.map((n) =>
                            page === 'home' ? (
                                <li key={n.name}>
                                    <a
                                        href={n.url}
                                        title={n.name}
                                        className={styles['footer-desktop-link']}
                                    >
                                        <Picture
                                            className={styles[`flag-icon`]}
                                            src={`static/flags/${n.flag.toLowerCase()}.png`}
                                            width={14}
                                            height={11}
                                            name={`${n.flag} - ${n.name}`}
                                            lazy
                                        />
                                        {n.name}
                                    </a>
                                </li>
                            ) : (
                                <li key={n.name}>
                                    <span
                                        onClick={() =>
                                            // eslint-disable-next-line no-undef
                                            window.location.href = n.url}
                                        title={n.name}
                                        className={styles['footer-desktop-link']}
                                    >
                                        <Picture
                                            className={styles[`flag-icon`]}
                                            src={`static/flags/${n.flag.toLowerCase()}.png`}
                                            width={14}
                                            height={11}
                                            name={`${n.flag} - ${n.name}`}
                                            lazy
                                        />
                                        {n.name}
                                    </span>
                                </li>
                            )
                        )}
                    </>
                )}
            </ul>
        </div>
    );
};

FooterContent.propTypes = {
    showBlogLink: PropTypes.bool,
    stores: PropTypes.array,
    rating: PropTypes.object,
};

const FooterSprite = ({ icons }) => {
    const { paymentMethods, shippingMethods, security, mobileApp } = icons;

    return (
        <div className={styles[`footer-desktop-icons`]}>
            {paymentMethods.length && (
                <>
                    <div className={styles['footer-desktop-icon-wrapper']}>
                        <p className={styles['footer-desktop-icon-title']}>
                            <strong>
                                <I18n>footer.sprite.payment_methods</I18n>
                            </strong>
                        </p>
                        <div className={styles['footer-desktop-icon-type']}>
                            {paymentMethods.map(m =>
                                m.url ? (
                                    <a className={styles['icon-footer']} href={m.url} rel="nofollow noopener noreferrer" title={m.method} target="_blank" key={m.method}>
                                        <Picture
                                            lazy
                                            src={`/static/layout/icons/${m.img}`}
                                            width={m.width}
                                            name={m.method}
                                        />
                                    </a>
                                ) : (
                                    <span className={styles['icon-footer']} key={m.method}>
                                        <Picture
                                            lazy
                                            src={`/static/layout/icons/${m.img}`}
                                            width={m.width}
                                            name={m.method}
                                        />
                                    </span>
                                )
                            )}
                        </div>
                    </div>
                    <div className={styles['separator']} />
                </>
            )}
            {shippingMethods.length && (
                <>
                    <div className={styles['footer-desktop-icon-wrapper']}>
                        <p className={styles['footer-desktop-icon-title']}>
                            <strong>
                                <I18n>footer.sprite.shipping</I18n>
                            </strong>
                        </p>
                        <div className={styles['footer-desktop-icon-type']}>
                            {shippingMethods.map(m => (
                                <span className={styles['icon-footer']} key={m.method}>
                                    <Picture lazy src={`/static/layout/icons/${m.img}`} width={m.width} name={m.method} />
                                </span>
                            ))}
                        </div>
                    </div>
                    <div className={styles['separator']} />
                </>
            )}
            {security.length && (
                <>
                    <div className={`${styles['footer-desktop-icon-wrapper']} ${styles['footer-desktop-security']}`}>
                        <p className={styles['footer-desktop-icon-title']}>
                            <strong>
                                <I18n>footer.sprite.secure</I18n>
                            </strong>
                        </p>
                        <div className={styles['footer-desktop-icon-type']}>
                            {security.map(t => (
                                <span className={styles['icon-footer']} key={t.type}>
                                    <Picture lazy src={`/static/layout/icons/${t.img}`} width={t.width} name={t.method} />
                                </span>
                            ))}
                        </div>
                    </div>
                    <div className={styles['separator']} />
                </>
            )}
            {mobileApp.length ? (
                <div className={`${styles['footer-desktop-icon-wrapper']} ${styles['footer-desktop-apps']}`}>
                    <p className={styles['footer-desktop-icon-title']}>
                        <strong>
                            <I18n>footer.sprite.app_deporvillage</I18n>
                        </strong>
                    </p>
                    <div className={styles['footer-desktop-icon-type']}>
                        {mobileApp.map(m => (
                            <a href={m.url} className={styles['icon-footer']} key={m.type} rel="nofollow noopener noreferrer" target="_blank" title={m.type}>
                                <Picture lazy src={`/static/layout/icons/${m.img}`} width={m.width} name={m.method} />
                            </a>
                        ))}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

FooterSprite.propTypes = {
    icons: PropTypes.object,
};

const FooterXXSS = () => {
    const { translate } = useContext(I18nContext);
    return (
        <div className={styles['footer-desktop-xxss']}>
            <a rel="nofollow noopener noreferrer" href={translate("footer.rrss.facebook")} target="_blank" className={styles['xxss']}>
                <span className="icon icon-facebook-f" />
            </a>
            <a rel="nofollow noopener noreferrer" href={translate("footer.rrss.instagram")} target="_blank" className={styles['xxss']}>
                <span className="icon icon-instagram icon-expand" />
            </a>
            <a rel="nofollow noopener noreferrer" href={translate("footer.rrss.strava")} target="_blank" className={styles['xxss']}>
                <span className="icon icon-strava icon-expand" />
            </a>
            <a rel="nofollow noopener noreferrer" href={translate("footer.rrss.youtube")} target="_blank" className={styles['xxss']}>
                <span className="icon icon-youtube icon-expand" />
            </a>
            <a rel="nofollow noopener noreferrer" href={translate("footer.rrss.twitter")} target="_blank" className={styles['xxss']}>
                <span className="icon icon-twitter" />
            </a>
        </div>
    );
};

const FooterCopyright = () => {
    const year = new Date().getFullYear();
    const { translate } = useContext(I18nContext);
    return (
        <div className={styles['footer-desktop-copyright']}>

            <p>
                <I18n>footer.legal.description</I18n>
            </p>

            <p>
                <span dangerouslySetInnerHTML={{
                    __html: translate("footer.legal.copyright", {
                        current_year: year
                    })
                }}
                /> | <a rel="nofollow" href={translate("footer.links.legal_conditions_link")}>
                    <I18n>footer.links.legal_conditions</I18n>
                </a> | <a rel="nofollow" href={translate("footer.links.privacy_policy_link")}>
                    <I18n>footer.links.privacy_policy</I18n>
                </a> | <a rel="nofollow" href={translate("footer.links.cookies_policy_link")}>
                    <I18n>footer.links.cookies_policy</I18n>
                </a> | <a rel="nofollow" href={translate("footer.links.general_conditions_link")}>
                    <I18n>footer.links.general_conditions</I18n>
                </a>
            </p>

            <p>
                <I18n>footer.legal.cif</I18n>
            </p>
        </div>
    );
};

const FooterDesktop = ({ model }) => {

    const { showBlogLink, icons, stores, rating } = model;

    return (
        <footer className={styles[`footer-desktop-component`]}>
            <FooterContent showBlogLink={showBlogLink} stores={stores} rating={rating} />
            <hr />
            <FooterSprite icons={icons} />
            <FooterXXSS />
            <FooterCopyright />
        </footer>
    );
};

FooterDesktop.propTypes = {
    model: PropTypes.object
};

export default FooterDesktop;
